import React from 'react';
import { NavLink } from "react-router-dom";
import Logo from './Logo';
import MobileMenu from './MobileMenu';
import '../App.css';

const Header = () =>{
    return (
        <header className="site-header">
            <div className="site-header-row">
                {/* Logo — left */}
                <Logo />

                {/* Desktop nav — right, hidden on mobile */}
                <nav className="site-nav hidden tablet:flex">
                    <ul className="site-nav-list">
                        <li className="undotted">
                            <NavLink to="/">Claims</NavLink>
                        </li>
                        {/* Hidden until ready to launch publicly
                        <li className="undotted">
                            <NavLink to="/organisations">Organisations</NavLink>
                        </li>
                        <li className="undotted">
                            <NavLink to="/materials">Materials</NavLink>
                        </li>
                        <li className="undotted">
                            <NavLink to="/incidents">Incidents</NavLink>
                        </li>
                        <li className="undotted nav-dropdown">
                            <button className="nav-dropdown-toggle">Get involved</button>
                            <ul className="nav-dropdown-menu">
                                <li>
                                    <NavLink to="/submit">Submit</NavLink>
                                </li>
                                <li>
                                    <NavLink to="/contact">Get in touch</NavLink>
                                </li>
                            </ul>
                        </li>
                        */}
                        <li className="undotted">
                            <NavLink to="/about">About</NavLink>
                        </li>
                    </ul>
                </nav>

                {/* Mobile hamburger — right, hidden on desktop via CSS media query */}
                <div className="mobile-menu-toggle">
                    <MobileMenu />
                </div>
            </div>
        </header>
    );
}

export default Header;
